/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './MobileCustomizeAccounts.scss';
import './MobileCustomAccountGroups.scss';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import Store from 'state/Store';
import { NavLink } from 'react-router-dom';

import { NON_BREAKING_SPACE } from 'services/Formats';
import PreferencesHeader from 'components/layouts/Preferences/PreferencesHeader';
import PreferencesSection from 'components/layouts/Preferences/shared/PreferencesSection';
import PreferencesRow from 'components/layouts/Preferences/shared/PreferencesRow';
import PreferencesCol from 'components/layouts/Preferences/shared/PreferencesCol';
import CreateCustomAccountsGroup from 'components/layouts/Preferences/CustomizeAccountsView/CreateCustomAccountsGroupModal';
import MobileViewCustomAccounts from './MobileViewCustomAccounts';

import BaseModal from 'components/shared/Modal/BaseModal';
import {
  setCustomAccount,
  refreshCustomAccountGroups
} from 'state/preferences/PreferencesActions';

class MobileCustomAccountGroups extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      accountSelectorModalOpen: false
    };
  }

  handleModalClose = () => {
    this.setState({ accountSelectorModalOpen: false }, () => {
      Store.dispatch(refreshCustomAccountGroups());
    });
  };

  handleModalOpen = () => {
    Store.dispatch(setCustomAccount());
    this.setState({ accountSelectorModalOpen: true });
  };

  render() {
    const { customGroups } = this.props;
    const { accountSelectorModalOpen } = this.state;
    return (
      <Fragment>
        <PreferencesHeader>
          <div className="mobile-customize-accounts-view-header">
            Custom Account Groups
          </div>
        </PreferencesHeader>
        <PreferencesSection
          fullBackground={true}
          className="mobile-custom-group-spacing">
          <PreferencesRow>
            <PreferencesCol col={12} className="mobile-custom-account-list">
              {customGroups && (
                <MobileViewCustomAccounts customGroups={customGroups} />
              )}
            </PreferencesCol>
          </PreferencesRow>
        </PreferencesSection>

        <PreferencesRow>
          <PreferencesCol col={12}>
            <div className="mobile-customize-accounts-view-footer">
              <div>
                Creating custom account groups allows you to aggregate accounts
                that have the same investment goals.
              </div>
              <div className="mobile-account-group-info">
                Custom Groups can be used on the{NON_BREAKING_SPACE}
                <span className="mobile-links">
                  <NavLink to="/accounts">Accounts</NavLink>
                </span>
                ,{NON_BREAKING_SPACE}
                <span className="mobile-links">
                  <NavLink to="/transactions">Transactions</NavLink>
                </span>
                {NON_BREAKING_SPACE}and{NON_BREAKING_SPACE}
                <span className="mobile-links">
                  <NavLink to="/taxes">Taxes</NavLink>
                </span>
                {NON_BREAKING_SPACE}pages.
              </div>
            </div>
          </PreferencesCol>
        </PreferencesRow>
        <PreferencesRow className="mobile-newgroup-button-container">
          <PreferencesCol col={12}>
            <div className="mobile-customize-accounts-view-footer customize-accounts-mobile-add-new-group">
              <button
                className="customize-accounts-save-button-mobile"
                onClick={this.handleModalOpen}>
                New Group
              </button>
            </div>
          </PreferencesCol>
        </PreferencesRow>

        <BaseModal
          close={this.handleModalClose}
          hideAnchor={true}
          hideClose={true}
          isOpen={accountSelectorModalOpen}
          label="account-selection-modal"
          title={'New Custom Group'}
          className="customize-accounts-modal">
          <CreateCustomAccountsGroup close={this.handleModalClose} />
        </BaseModal>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    customGroups: state.customerPreferences.customAccountGroups
  };
};

export default connect(mapStateToProps)(MobileCustomAccountGroups);
